// extracted by mini-css-extract-plugin
export var categories = "page-module--categories--5d4cd";
export var categoriesHeadline = "page-module--categoriesHeadline--37014 typography-module--base--16985";
export var grid = "page-module--grid--66064";
export var gridRelated = "page-module--gridRelated--2a1f1";
export var mainContent = "page-module--mainContent--cd9dc";
export var mainImage = "page-module--mainImage--c50c7";
export var metaContent = "page-module--metaContent--c35d0";
export var publishedAt = "page-module--publishedAt--aa556 typography-module--small--2877f";
export var relatedProjects = "page-module--relatedProjects--3a026";
export var relatedProjectsHeadline = "page-module--relatedProjectsHeadline--f2173 typography-module--base--16985";
export var root = "page-module--root--3aa68";
export var title = "page-module--title--eca59 typography-module--responsiveTitle1--d2dd2";